import { FilledLinkToWebField } from '@prismicio/client';
import classNames from 'classnames';
import {
    PerformancePageDocumentDataFooterLinksItem,
    Simplify,
} from 'prismicio-types';
import styles from './performance.module.scss';

export interface FooterProps {
    links?: Array<Simplify<PerformancePageDocumentDataFooterLinksItem>>;
    copyright?: string;
}

const Footer = (props: FooterProps) => {
    return (
        <footer className={classNames('footer', styles['footer'])}>
            <div className="container flex items-center justify-between">
                <div className={styles['footer__mosh']}>
                    {props.copyright && '© ' + props.copyright}
                </div>
                {props.links && (
                    <ul className={styles['footer__menu']}>
                        {props.links.map((linkItem, index) => (
                            <li key={index} className={'py-4'}>
                                <a
                                    className={'hover:underline'}
                                    href={
                                        (linkItem.link as FilledLinkToWebField)
                                            .url
                                    }
                                    title={linkItem.label || ''}
                                >
                                    {linkItem.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </footer>
    );
};

export default Footer;
